/**
 * Remembers each media item's aspect ratio once it has loaded.
 *
 * In a virtualized feed a post is unmounted when it scrolls far away and mounted again when it
 * returns. Media without stored dimensions only learns its ratio after it loads, so on re-mount it
 * would start with a default height and then jump. Remembering the ratio lets it reserve the right
 * space immediately. Keys ignore the query string (signed URLs change between requests).
 */
const MAX_ENTRIES = 1000;
const cache = new Map();

const keyOf = (url) => (typeof url === 'string' && url ? url.split('?')[0] : null);

export const getCachedAspectRatio = (url) => {
  const key = keyOf(url);
  return key ? cache.get(key) || null : null;
};

export const setCachedAspectRatio = (url, ratio) => {
  const key = keyOf(url);
  if (!key || !Number.isFinite(ratio) || ratio <= 0) return;
  cache.delete(key);
  cache.set(key, ratio);
  if (cache.size > MAX_ENTRIES) cache.delete(cache.keys().next().value);
};
